<template>
<div class="row">
    <div class="col-lg-12">
        <div class="mt-3">
            <p class="font-weight-bold mb-0">{{ $t('full_proposal_ev.admissibility__reference') }}</p>
            <span>{{ EvaluationForm.proposal.reference }}</span>
        </div>
        <div class="mt-3">
            <p class="font-weight-bold mb-0">{{ $t('full_proposal_ev.general__info_grid_by') }}</p>
            <span v-if="EvaluationForm.evaluation && EvaluationForm.evaluation.evaluator">{{ EvaluationForm.evaluation.evaluator.name }}</span>
            <span v-else>-</span>
        </div>
    </div>
</div>
</template>
<script>
import { EvaluationForm } from "@/services";

export default
{
    data()
    {
        return {
            EvaluationForm
        }
    }
}
</script>
